/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Fail_Cancel_RetryInputs */

const en_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error canceling your plan. Try again.`)
};

const id_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada kesalahan saat membatalkan rencana Anda. Coba lagi.`)
};

const ms_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terdapat ralat semasa membatalkan pelan anda. Cuba lagi.`)
};

const ca_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi ha hagut un error en cancel·lar el teu pla. Torna-ho a provar.`)
};

const cs_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Při rušení vašeho plánu došlo k chybě. Zkuste to znovu.`)
};

const da_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der skete en fejl ved annulleringen af dit abonnement. Prøv igen.`)
};

const de_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gab einen Fehler beim Kündigen Ihres Plans. Versuchen Sie es erneut.`)
};

const et_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie plaani tühistamisel ilmnes viga. Proovige uuesti.`)
};

const es_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha producido un error al cancelar tu plan. Inténtalo de nuevo.`)
};

const fr_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s’est produite lors de l’annulation de votre abonnement. Veuillez réessayer.`)
};

const hr_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Došlo je do pogreške prilikom otkazivanja vašeg plana. Pokušajte ponovo.`)
};

const it_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante l'annullamento del tuo piano. Riprova.`)
};

const lv_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plāna atcelšanas laikā radās kļūda. Mēģiniet vēlreiz.`)
};

const lt_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įvyko klaida atšaukiant jūsų planą. Bandykite dar kartą.`)
};

const hu_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba történt a terv törlésénél. Próbálja újra.`)
};

const nl_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er was een probleem met het verwerken van je opdracht. Probeer opnieuw.`)
};

const nb_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det oppsto en feil ved kanselleringen av abonnementet. Prøv igjen.`)
};

const pl_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wystąpił błąd podczas anulowania planu. Spróbuj ponownie.`)
};

const pt_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao cancelar seu plano. Tente novamente.`)
};

const ro_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A apărut o eroare la anularea planului dvs. Încercați din nou.`)
};

const sk_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyskytla sa chyba pri rušení vášho plánu. Skúste to znova.`)
};

const sl_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prišlo je do napake pri preklicu vašega načrta. Poskusite znova.`)
};

const fi_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapahtui virhe suunnitelman peruutuksessa. Yritä uudelleen.`)
};

const sv_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det uppstod ett fel när din plan avbokades. Försök igen.`)
};

const vi_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có lỗi xảy ra khi hủy kế hoạch của bạn. Thử lại.`)
};

const tr_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planınızı iptal ederken bir hata oluştu. Tekrar deneyin.`)
};

const el_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παρουσιάστηκε σφάλμα κατά την ακύρωση του πλάνου σας. Δοκιμάστε ξανά.`)
};

const bg_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Възникна грешка при анулирането на плана. Опитайте отново.`)
};

const ru_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При отмене вашего плана произошла ошибка. Повторите попытку.`)
};

const sr_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дошло је до грешке приликом отказивања вашег плана. Покушајте поново.`)
};

const uk_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виникла помилка при скасуванні вашого плану. Спробуйте ще раз.`)
};

const ka_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გასწორდა შეცდომა თქვენი გეგმის გაუქმებაში. სცადეთ კვლავ.`)
};

const hi_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी योजना रद्द करने में एक त्रुटि हुई। पुन: प्रयास करें।`)
};

const th_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกิดข้อผิดพลาดในการยกเลิกแผนของคุณ โปรดลองอีกครั้ง`)
};

const ko_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜 취소 중 오류가 발생했습니다. 다시 시도하세요.`)
};

const zh_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消您的套餐时出错了。请重试。`)
};

const zh_tw_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消您的方案時發生錯誤。請重試。`)
};

const ja_error_fail_cancel_retry = /** @type {(inputs: Error_Fail_Cancel_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランのキャンセル中にエラーが発生しました。もう一度お試しください。`)
};

/**
* | output |
* | --- |
* | "There was an error canceling your plan. Try again." |
*
* @param {Error_Fail_Cancel_RetryInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const error_fail_cancel_retry = /** @type {((inputs?: Error_Fail_Cancel_RetryInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Fail_Cancel_RetryInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_error_fail_cancel_retry(inputs)
	if (locale === "ms") return ms_error_fail_cancel_retry(inputs)
	if (locale === "ca") return ca_error_fail_cancel_retry(inputs)
	if (locale === "cs") return cs_error_fail_cancel_retry(inputs)
	if (locale === "da") return da_error_fail_cancel_retry(inputs)
	if (locale === "de") return de_error_fail_cancel_retry(inputs)
	if (locale === "et") return et_error_fail_cancel_retry(inputs)
	if (locale === "es") return es_error_fail_cancel_retry(inputs)
	if (locale === "fr") return fr_error_fail_cancel_retry(inputs)
	if (locale === "hr") return hr_error_fail_cancel_retry(inputs)
	if (locale === "it") return it_error_fail_cancel_retry(inputs)
	if (locale === "lv") return lv_error_fail_cancel_retry(inputs)
	if (locale === "lt") return lt_error_fail_cancel_retry(inputs)
	if (locale === "hu") return hu_error_fail_cancel_retry(inputs)
	if (locale === "nl") return nl_error_fail_cancel_retry(inputs)
	if (locale === "nb") return nb_error_fail_cancel_retry(inputs)
	if (locale === "pl") return pl_error_fail_cancel_retry(inputs)
	if (locale === "pt") return pt_error_fail_cancel_retry(inputs)
	if (locale === "ro") return ro_error_fail_cancel_retry(inputs)
	if (locale === "sk") return sk_error_fail_cancel_retry(inputs)
	if (locale === "sl") return sl_error_fail_cancel_retry(inputs)
	if (locale === "fi") return fi_error_fail_cancel_retry(inputs)
	if (locale === "sv") return sv_error_fail_cancel_retry(inputs)
	if (locale === "vi") return vi_error_fail_cancel_retry(inputs)
	if (locale === "tr") return tr_error_fail_cancel_retry(inputs)
	if (locale === "el") return el_error_fail_cancel_retry(inputs)
	if (locale === "bg") return bg_error_fail_cancel_retry(inputs)
	if (locale === "ru") return ru_error_fail_cancel_retry(inputs)
	if (locale === "sr") return sr_error_fail_cancel_retry(inputs)
	if (locale === "uk") return uk_error_fail_cancel_retry(inputs)
	if (locale === "ka") return ka_error_fail_cancel_retry(inputs)
	if (locale === "hi") return hi_error_fail_cancel_retry(inputs)
	if (locale === "th") return th_error_fail_cancel_retry(inputs)
	if (locale === "ko") return ko_error_fail_cancel_retry(inputs)
	if (locale === "zh") return zh_error_fail_cancel_retry(inputs)
	if (locale === "zh-tw") return zh_tw_error_fail_cancel_retry(inputs)
	if (locale === "ja") return ja_error_fail_cancel_retry(inputs)
	return en_error_fail_cancel_retry(inputs)
});